import { render, staticRenderFns } from "./ClientManagementPanel.vue?vue&type=template&id=c4f33dd6&scoped=true"
import script from "./ClientManagementPanel.vue?vue&type=script&lang=js"
export * from "./ClientManagementPanel.vue?vue&type=script&lang=js"
import style0 from "./ClientManagementPanel.vue?vue&type=style&index=0&id=c4f33dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f33dd6",
  null
  
)

export default component.exports